var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeshape4C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes_x5F_1a"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    fill: "#DEA65F",
    enableBackground: "new    ",
    d: "M381.9,266.1c1.4-1.7,2.7-3.3,4.1-4.8c2.8-3,6.1-5.2,9.7-6.7 c1.8-0.8,3.7-1.4,5.7-1.8c9.8-2.1,20.1-0.2,27.4,6.7c1,1.1,1.9,2.4,2.7,3.7c0.7,1.3,1.3,2.6,1.5,3.7c-9.4,2.5-17.5,8.1-27.6,8.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M395.4,261.1c-6.9,0.9-14.2,6.5-18.5,11.5c2.9,3.1,6.7,5.3,10.8,6.5c10.1,3.1,22.5,0.6,31.2-8.4 C411.9,263,404.7,259.4,395.4,261.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA17B",
    d: "M396.8,279.5c5.9,0,10.7-4.8,10.7-10.7c0-3.1-1.3-5.8-3.4-7.7c-2.7-0.6-5.6-0.6-8.7-0.1 c-2.7,0.3-5.5,1.4-8.1,2.9c-0.8,1.5-1.2,3.1-1.2,4.9C386.1,274.8,390.9,279.5,396.8,279.5z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.21,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 398.4,
    cy: 269.8,
    rx: 6.2,
    ry: 6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    enableBackground: "new    ",
    d: "M389.8,269.2c0-0.8,0.1-1.6,0.4-2.3c-0.6,1-1,2.2-1,3.5c0,3.9,3.3,7,7.3,7 c1.1,0,2.1-0.2,3-0.6c-0.5,0.1-1,0.2-1.6,0.2C393.4,277,389.8,273.5,389.8,269.2z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#471F12",
    cx: 397.2,
    cy: 268.9,
    rx: 6.2,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B1A0F",
    d: "M428.4,270c0.6-0.1,1.2-0.3,1.8-0.5c0.6-0.2,1.2-0.4,1.8-0.6c2.5-1.1,3.4-2.5,4.7-4.3 c-0.5,0.3-1,0.6-1.5,0.8c-0.7,0.3-1.4,0.5-2.1,0.7c-3.2,1-6.1,0.7-8.9-0.3c-0.2-0.1-0.4-0.2-0.6-0.2c2.2-0.2,4.3-0.8,6.3-1.8 c2.5-1.3,3.8-3,5.1-5.4c-0.4,0.4-0.9,0.8-1.4,1.1c-3.7,2.4-10.2,4.8-14.8,3.5c-0.2-0.1-0.3-0.2-0.5-0.3c3.6-0.3,9.6-4.6,10.1-8.2 c-0.3,0.3-0.6,0.6-0.9,0.8c-2.1,1.7-4,3.3-6.7,4.1c-1.3,0.4-2.5,0.6-3.8,0.8c-0.7,0.1-1.6,0.1-2.4,0.1c-0.5,0-1,0-1.4,0.1 c0.3-0.2,0.6-0.3,0.9-0.5c2.5-1.4,5.4-3.6,5.8-6.4c-1,1.7-2.9,2.6-4.4,3.5c-1,0.7-2,1.3-3,1.8c-0.7,0.4-1.4,0.8-2.1,1.2 c0.6-0.3,1.1-0.9,1.5-1.6c0.8-1.2,1.3-2.7,2-3.7c-0.8,0.9-2.4,2.2-3.7,2.6c-5.7-3.3-11.7-5.6-17.6-2.5c-0.6,0.3-1.3,0.7-1.9,1.2 c-0.3,0.2-0.6,0.5-0.9,0.8c6.2-3,12.7-2.4,17.7,1.8c-11.6-2.7-25.2,3.4-30.9,13.6c-0.1,0.3-0.3,0.5-0.4,0.8 c0.2-0.2,0.4-0.4,0.6-0.7c4.3-5,11.6-10.6,18.5-11.5c9.3-1.7,16.5,2,23.5,9.6c-8.7,9.1-21.1,11.6-31.2,8.4c0.3,0.3,0.7,0.6,1,0.7 c11.7,4.9,16.3,1.5,23.6-1.1c0.4-0.2,1.4-0.8,2.3-1.4c3.1-0.5,6.5-0.3,9.2,1.3c-0.9-1.7-3.5-3-5.6-3.4c-0.4-0.1-0.7-0.1-1.1-0.1 c0.5-0.2,1.2-0.3,1.8-0.3c2.9-0.2,6.8,0.8,8.8,1.9c-1.2-1.7-4.6-3-6.7-3.1c0,0,0,0,0.1,0c3.6-0.4,7.5,0.3,10.8,1.3 c-1.6-1.3-3.2-2.1-5.2-2.7c-0.8-0.2-1.6-0.4-2.3-0.6c0.3-0.2,0.7-0.3,1-0.5C426.5,270.7,427.4,270.3,428.4,270z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 400.2,
    cy: 270.4,
    rx: 1.4,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403,266.7c-0.9-2.2-3.1-3.8-5.8-3.8c-2.8,0-5.2,1.9-6,4.4C394.9,265.6,399.2,265.7,403,266.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.83,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 391.6,
    cy: 266.9,
    rx: 3,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    fill: "#DEA65F",
    enableBackground: "new    ",
    d: "M331.2,266.1c-1.4-1.7-2.7-3.3-4.1-4.8 c-2.8-3-6.1-5.2-9.7-6.7c-1.8-0.8-3.7-1.4-5.7-1.8c-9.8-2.1-20.1-0.2-27.4,6.7c-1,1.1-1.9,2.4-2.7,3.7c-0.7,1.3-1.3,2.6-1.5,3.7 c9.4,2.5,17.5,8.1,27.6,8.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M317.7,261.1c6.9,0.9,14.2,6.5,18.5,11.5c-2.9,3.1-6.7,5.3-10.8,6.5c-10.1,3.1-22.5,0.6-31.2-8.4 C301.2,263,308.4,259.4,317.7,261.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9DA17B",
    d: "M316.3,279.5c-5.9,0-10.7-4.8-10.7-10.7c0-3.1,1.3-5.8,3.4-7.7c2.7-0.6,5.6-0.6,8.7-0.1 c2.7,0.3,5.5,1.4,8.1,2.9c0.8,1.5,1.2,3.1,1.2,4.9C327,274.8,322.2,279.5,316.3,279.5z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.21,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 314.7,
    cy: 269.8,
    rx: 6.2,
    ry: 6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    enableBackground: "new    ",
    d: "M323.2,269.2c0-0.8-0.1-1.6-0.4-2.3c0.6,1,1,2.2,1,3.5c0,3.9-3.3,7-7.3,7 c-1.1,0-2.1-0.2-3-0.6c0.5,0.1,1,0.2,1.6,0.2C319.6,277,323.2,273.5,323.2,269.2z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#471F12",
    cx: 315.9,
    cy: 268.9,
    rx: 6.2,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B1A0F",
    d: "M284.7,270c-0.6-0.1-1.2-0.3-1.8-0.5c-0.6-0.2-1.2-0.4-1.8-0.6c-2.5-1.1-3.4-2.5-4.7-4.3 c0.5,0.3,1,0.6,1.5,0.8c0.7,0.3,1.4,0.5,2.1,0.7c3.2,1,6.1,0.7,8.9-0.3c0.2-0.1,0.4-0.2,0.6-0.2c-2.2-0.2-4.3-0.8-6.3-1.8 c-2.5-1.3-3.8-3-5.1-5.4c0.4,0.4,0.9,0.8,1.4,1.1c3.7,2.4,10.2,4.8,14.8,3.5c0.2-0.1,0.3-0.2,0.5-0.3c-3.6-0.3-9.6-4.6-10.1-8.2 c0.3,0.3,0.6,0.6,0.9,0.8c2.1,1.7,4,3.3,6.7,4.1c1.3,0.4,2.5,0.6,3.8,0.8c0.7,0.1,1.6,0.1,2.4,0.1c0.5,0,1,0,1.4,0.1 c-0.3-0.2-0.6-0.3-0.9-0.5c-2.5-1.4-5.4-3.6-5.8-6.4c1,1.7,2.9,2.6,4.4,3.5c1,0.7,2,1.3,3,1.8c0.7,0.4,1.4,0.8,2.1,1.2 c-0.6-0.3-1.1-0.9-1.5-1.6c-0.8-1.2-1.3-2.7-2-3.7c0.8,0.9,2.4,2.2,3.7,2.6c5.7-3.3,11.7-5.6,17.6-2.5c0.6,0.3,1.3,0.7,1.9,1.2 c0.3,0.2,0.6,0.5,0.9,0.8c-6.2-3-12.7-2.4-17.7,1.8c11.6-2.7,25.2,3.4,30.9,13.6c0.1,0.3,0.3,0.5,0.4,0.8 c-0.2-0.2-0.4-0.4-0.6-0.7c-4.3-5-11.6-10.6-18.5-11.5c-9.3-1.7-16.5,2-23.5,9.6c8.7,9.1,21.1,11.6,31.2,8.4 c-0.3,0.3-0.7,0.6-1,0.7c-11.7,4.9-16.3,1.5-23.6-1.1c-0.4-0.2-1.4-0.8-2.3-1.4c-3.1-0.5-6.5-0.3-9.2,1.3c0.9-1.7,3.5-3,5.6-3.4 c0.4-0.1,0.7-0.1,1.1-0.1c-0.5-0.2-1.2-0.3-1.8-0.3c-2.9-0.2-6.8,0.8-8.8,1.9c1.2-1.7,4.6-3,6.7-3.1c0,0,0,0-0.1,0 c-3.6-0.4-7.5,0.3-10.8,1.3c1.6-1.3,3.2-2.1,5.2-2.7c0.8-0.2,1.6-0.4,2.3-0.6c-0.3-0.2-0.7-0.3-1-0.5 C286.6,270.7,285.7,270.3,284.7,270z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 312.8,
    cy: 270.4,
    rx: 1.4,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.1,266.7c0.9-2.2,3.1-3.8,5.8-3.8c2.8,0,5.2,1.9,6,4.4C318.2,265.6,313.9,265.7,310.1,266.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.83,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 321.4,
    cy: 266.9,
    rx: 3,
    ry: 2.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeshape4C);
export default __webpack_public_path__ + "static/media/eyeshape_4c.702156b73c9c8209b5686b2a356de8d8.svg";
export { ForwardRef as ReactComponent };